import React, { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Dash from './dash';
import BacPieChart from './dash/sub-dash/BacPieChart';
import BacTable from './dash/sub-dash/BacTable';
import BacBarChart from './dash/sub-dash/BacBarChart';
import { sumData } from 'utils';
import { bar22, pie21 } from 'utils/colors';
import styled from "styled-components";
import DataContext from 'context/DataContext';
import { REPARTITIONBARLABELS, REPARTITIONPIELABELS, REPARTITIONTABLABELS } from 'utils/constants';
import { device, sizes } from 'utils/breakpoints';
import { useDeviceWidth } from 'utils/useDeviceDetect';
const StyledContainer = styled(Container)`
  height: 100%;
  @media only screen and ${device.xs}{
    .row-1-1, .row-1-2, .row-2-1, .row-2-2 {
      border-bottom-width: 0;
    }
  }
  @media only screen and ${device.sm}{
    .row-1-1 {
      border-right-width: 0;
      border-bottom-width: 0;
    }
    .row-1-2 {
      border-bottom-width: 0;
    }
    .row-2-1 {
      border-right-width: 0;
    }
    .row-2-1, .row-2-2 {
      border-bottom-width: 0;
    }
  }
  @media only screen and ${device.md}{
    .row-1-1 {
      border-right-width: 0;
      border-bottom-width: 0;
    }
    .row-1-2 {
      border-bottom-width: 0;
    }
    .row-2-2, .row-2-1 {
      border-right-width: 0;
    }
    .page-row-1 {
      height: 451px;
    }
    .page-row-2 {
      height: 454px;
    }
  }
`;
const getColumnsNumber = (wdth) => {
  if(wdth <= sizes.sm) {
    return 2;
  }
  return 1;
}
const Repartition = () => {
  const wdth = useDeviceWidth();
  const {
    dataContext: { repartition: {anomaliesByTypeForYear2022,anomaliesByTypeForYear,  anomaliesByTypeAndLocation2022} },
  } = useContext(DataContext);
  const newData = Object.keys(anomaliesByTypeForYear2022[0]).filter((key) => {
    return key !== 'year'
  }).map((key) => {
    return {
      name: REPARTITIONPIELABELS[key],
      value: anomaliesByTypeForYear2022[0][key]
    }
  });
  const barLabels = Object.keys(anomaliesByTypeForYear[0]).filter((item) => item !== 'year').map((item) => {
    return {
      name: REPARTITIONBARLABELS[item]
    }
  });
  return (
    <StyledContainer>
      <Row className='page-row-1'>
        <Col xs="12" sm="6" md="6" className="row-1-1">
          <Dash title="Répartition Anomalies par catégorie (12 derniers mois)">
            <BacPieChart
              data={newData}
              colors={pie21}
              displayValue={false}
            />
          </Dash>
        </Col>
        <Col xs="12" sm="6" md="6" className="row-1-2">
          <Dash title="Répartition Anomalies par catégorie et par année">
            <BacBarChart
              data={anomaliesByTypeForYear}
              colors={bar22}
              barLabels={barLabels}
              columnsNumber={getColumnsNumber(wdth)}
            />
          </Dash>
        </Col>
      </Row>
      <Row className='page-row-2'>
        <Col md="12">
          <Dash title="Répartition Anomalies par centre et par catégorie (2022)">
            <BacTable
              data={[...anomaliesByTypeAndLocation2022, sumData(anomaliesByTypeAndLocation2022)]}
              dataHead={Object.keys(anomaliesByTypeAndLocation2022[0]).map(item => REPARTITIONTABLABELS[item])}
            />
          </Dash>
        </Col>
      </Row>
    </StyledContainer>
  );
};

export default Repartition;
